export enum QueryType {
  NESTED = 0,
  RANGE = 1,
  DROPDOWN = 2,
  MATCHALL = 3,
  QUERY = 4,
  CHECKBOX = 5
}
